import { render, staticRenderFns } from "./showList.vue?vue&type=template&id=ff5f2a54&scoped=true&"
import script from "./showList.vue?vue&type=script&lang=js&"
export * from "./showList.vue?vue&type=script&lang=js&"
import style0 from "./showList.vue?vue&type=style&index=0&id=ff5f2a54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5f2a54",
  null
  
)

export default component.exports